module.exports = __webpack_public_path__ + "static/media/DutyPlanner.6ac2f310.jpeg";